import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBottomNavigation,{attrs:{"value":_vm.activeBtn,"app":"","input-value":_vm.isVisible}},_vm._l((_vm.menu),function(option,index){return _c(VBtn,{key:index,attrs:{"to":option.to,"color":"primary","text":"","exact":""}},[_c('span',[_vm._v(_vm._s(option.text)+" ")]),_c(VIcon,[_vm._v(_vm._s(option.icon))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }